<script setup>
import axios from "axios";
import List from './List.vue';
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
const props = defineProps(['categoryId', 'moduleId', 'feedbackId']);
const store = useStore();
const productId = computed(() => store.getters.getProductId);
const title = ref('常见问题');
const list = ref([]);

onMounted(() => {
  const questionQueryData = {
    productId: productId.value,
    page: 0,
    size: 5,
    categoryId: props.categoryId,
    related: true,
    id: props.feedbackId,
    moduleId: props.moduleId,
  };
  axios.get('/question', { params: questionQueryData }).then(res => {
    if (res.data && res.data.content) {
      list.value = res.data.content;
      console.log('relate questions', res.data);
    } else {
      console.error('Invalid response data:', res.data);
    }
  }).catch(err => {
    console.log(err);
  });
});
</script>

<template>
  <List title="相关问题" :list="list" title-class="weak"/>
</template>

<style scoped lang="scss">

</style>
